import * as S from '../styled'

const WhatsAppPhone = () => (
  <S.Phone>
    (11) 4007-1380
  </S.Phone>
)

export default WhatsAppPhone
